<template>
    <div class="ssid">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="ssid.name" class="display-block">
                        {{ssid.name}}
                    </h4>
                    <h4 v-else>Create SSID</h4>
                    <h5 v-if="ssid.project">SSID - {{ssid.project.name}}</h5>
                </header>

                <fieldset>
                    <legend>SSID</legend>

                    <dl v-if="ssid.id && ssid.project && ssid.project.network_type === 1 ">
                        <dt>Address</dt>
                        <dd v-if="canModify">
                            <addressable addressable-type="App\SSID"
                                         :address-id="ssid.address ? ssid.address.id : null"
                                         :addressable-id="ssid.id"
                                         :afterSave="loadSSID">
                            </addressable>
                        </dd>
                        <dd v-else-if="ssid.address" v-html="ssid.address.address_html">
                        </dd>
                    </dl>

                    <form @submit.prevent="saveSSID" accept-charset="UTF-8" novalidate="novalidate"
                          v-if="canModify" data-vv-scope="ssid">
                        <div class="row">
                            <div class="col-sm-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('ssid.SSID[name]')}">
                                <label for="ssid-name">Name</label>
                                <input id="ssid-name"
                                       v-validate="'required'"
                                       v-model="ssid.name"
                                       name="SSID[name]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('ssid.SSID[name]')" class="help-block">
                                    {{ errors.first('ssid.SSID[name]') }}
                                </span>
                            </div>
                            <div class="col-sm-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('ssid.SSID[password]')}">
                                <label for="ssid-password">Password</label>
                                <input id="ssid-password"
                                       v-validate="'required'"
                                       v-model="ssid.password"
                                       name="SSID[password]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('ssid.SSID[password]')" class="help-block">
                                    {{ errors.first('ssid.SSID[password]') }}
                                </span>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-xs-6 form-group">
                                <button type="button" class="btn btn-sm btn-warning"
                                        v-if="ssid.id"
                                        @click="deleteSSID"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-6 form-group pull-right">
                                <button type="submit" class="btn btn-block btn-success" :disabled="loading">
                                    Save SSID
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="row" v-else>
                        <div class="col-sm-6 form-group">
                            <dl>
                                <dt>Name</dt>
                                <dd>{{ssid.name}}</dd>
                            </dl>
                        </div>
                        <div class="col-sm-6 form-group">
                            <dl>
                                <dt>Password</dt>
                                <dd>{{ssid.password}}</dd>
                            </dl>
                        </div>
                    </div>
                </fieldset>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },

            canModify: {
                required: true,
                type: Boolean
            },

            ssidId: {
                type: String,
                default: null
            },

            projectId: {
                type: String,
                default: null
            },

            afterSave: {
                default(){
                    return function(){
                    };
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                ssid: {
                    name: null,
                },

                showSSID: false,
            };
        },

        computed: {},

        watch: {
            ssidId(){
                if( this.ssidId ){
                    this.init();
                }
                else {
                    this.resetData();
                }
            }
        },

        methods: {

            /** SSID CRUD **/
            loadSSID(){
                var url = '/api/ssids/' + this.ssid.id;

                return axios.get( url )
                    .then( ( response ) => {
                        var ssid = response.data.SSID;

                        this.$set( this, 'ssid', ssid );
                    } );
            },

            saveSSID(){
                var url = '/api/ssids';

                return this.$validator.validateAll( 'ssid' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;

                            var ssid = this.ssid;

                            if( this.ssid.id ){
                                promise = axios.put( url + '/' + this.ssid.id, {
                                    SSID: ssid
                                } );
                            }
                            else {
                                ssid.project_id = this.projectId;

                                promise = axios.post( url, {
                                    SSID: ssid
                                } );
                            }

                            promise.then( ( result ) => {
                                if( !this.ssid.id ){
                                    this.ssid = result.data.SSID;
                                }

                                return this.loadSSID();
                            } )
                                .then( () => {
                                    this.afterSave();

                                    this.$modal.hide( this.modalId );

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved SSID',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    this.$root.handleErrors( err, 'ssid' );
                                } );
                        }
                    } );
            },

            deleteSSID(){
                axios.delete( '/api/ssids/' + this.ssid.id )
                    .then( () => {
                        this.afterSave();

                        this.$modal.hide( this.modalId );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived SSID',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'ssid' );
                    } );
            },

            /** Hooks **/
            beforeClose(){
                if( this.ssidId === null ){
                    this.resetData();
                }

                this.$emit( 'before-close' );
            },

            init(){
                this.loading = true;

                var promise = Promise.resolve();

                if( this.ssidId ){
                    this.ssid.id = this.ssidId;

                    promise.then( () => {
                        return this.loadSSID();
                    } );
                }

                promise
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            /** Instance Functions **/
            openModal(){
                this.$modal.show( this.modalId );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },
        }
    }
</script>
